export default {
  fetch: (...args: Parameters<typeof fetch>) => globalThis.fetch(...args),
};
